import { Box, MainText, PressableOpacity } from "app/components/common";
import normalize from "app/utils/normalize";
import React from "react";
import { Image } from "react-native";
export interface ISmileyFeelingProps {
  smiley: string;
  text?: string;
  setFeeling?: () => void;
  isSelected?: boolean;
}

const SmileyFeeling = ({
  smiley = null,
  text = "",
  setFeeling = () => {},
  isSelected = false,
}: ISmileyFeelingProps) => {
  return (
    <PressableOpacity style={{ width: "25%" }} onPress={setFeeling}>
      <Box flexDirection="column" alignItems="center">
        <Box
          borderColor={isSelected ? "brand.500" : "neutral.75"}
          backgroundColor={isSelected ? "brand.100" : "neutral.75"}
          borderRadius={40}
          borderWidth={1}
          height={60}
          width={60}
          justifyContent="center"
          alignItems="center"
        >
          <Image
            style={{
              width: normalize(50),
              height: normalize(50),
            }}
            source={smiley}
          />
        </Box>
        {!!text && (
          <MainText
            numberOfLines={1}
            variant={isSelected ? "l3-bold" : "l3-medium"}
            color={isSelected ? "neutral.900" : "neutral.500"}
            textAlign="center"
            marginTop="xm"
          >
            {text}
          </MainText>
        )}
      </Box>
    </PressableOpacity>
  );
};

export default SmileyFeeling;
